import storeManager from '../../store/StoreManager';

const flaggedItemsReader = {
    isItemFlagged(contentRevisionId) {
        const { itemFlag: { flaggedItems } } = storeManager.getState();
        return flaggedItems.indexOf(`${contentRevisionId}`) > -1;
    },

    isItemFocused(contentRevisionId) {
        const { itemFlag: { focusedItem } } = storeManager.getState();
        return focusedItem === contentRevisionId;
    },
};

export default flaggedItemsReader;
